require('./bootstrap');

// import Lightbox from "@edsardio/alpine-lightbox";
// Alpine.plugin(Lightbox);

require('moment');
var Pikaday = require('pikaday');
// console.log('app.jsPikaday::')
// console.log(Pikaday)
window.Pikaday = Pikaday;

// require("pdfjs-dist"); 

import * as PDFJS from "pdfjs-dist/build/pdf.min.mjs"; 
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.min.mjs";
